/**
 * Content layers of a place, in order: collect → triage → passport → scout → target →
 * full facts → brief → texts → audio. Each layer writes only its own record and stamp,
 * so a rerun touches places without the stamp and never repays for the earlier ones.
 */
import { AttractionTriageVerdict } from './attraction-triage';

/** How deep a place goes. Set after scouting and route planning. */
export enum AttractionTierEnum {
    /** Stop of a ready route: full facts, brief, guide text, audio. */
    ROUTE = 'route',
    /** Worth a full audio story outside routes. */
    FULL = 'full',
    /** Short card from scout facts, no audio. Shown after an editor approves it. */
    LIGHT = 'light',
    /** Passport only; shown as a nearby recommendation. */
    SILENT = 'silent',
}

export type AttractionTriageRecord = {
    verdict: AttractionTriageVerdict;
    reason: string | null;
    /** Rough tourist interest 0–10, from the title and reference text only. */
    interest: number | null;
    checkedAt: string;
};

export enum AttractionScoutVerdictEnum {
    RICH = 'rich',
    MEDIUM = 'medium',
    POOR = 'poor',
}

export type AttractionScoutRecord = {
    /**
     * Story potential 0–10. Relative to the city once ranked: a lone scout rates almost
     * everything 8–9, so the city ranking spreads places by comparing their hooks.
     */
    score: number;
    /** The scout's own absolute guess, kept after ranking. */
    rawScore?: number;
    /** Place in the city ranking, 1 = strongest, out of `rankOf`. */
    rank?: number | null;
    rankOf?: number | null;
    rankedAt?: string | null;
    verdict: AttractionScoutVerdictEnum;
    /** Strongest story hooks, Russian. */
    hooks: string[];
    people: string[];
    events: string[];
    sourceCount: number;
    sources: string[];
    checkedAt: string;
    costUsd: number | null;
};
